import React from "react";
import { useLocation } from "react-router-dom";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useBranding } from "../pages/BrandingContext";
import ZyftPandaChatbot from "./ZyftPandaChatbot";
import {
  DashboardIcon,
  UsersIcon,
  SparklesIcon,
  PaletteIcon,
  SunIcon,
  MoonIcon,
  CalendarIcon,
  FolderIcon,
} from "./Icons";
import NotificationBell from "./NotificationBell";
import "./Layout.css";

const Layout = ({ children, darkMode, setDarkMode }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { branding } = useBranding();
  const location = useLocation();
  const isAIGiftingPage = location.pathname === "/gifting";

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="app-shell">
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="sidebar__brand">
          <div className="sidebar__logo">
            {branding?.logo_url ? (
              <img src={branding.logo_url} alt="Company logo" />
            ) : (
              <div className="sidebar__logoFallback">Z</div>
            )}
          </div>

          <div className="sidebar__brandText">
            <div className="sidebar__company">{branding?.company_name || "Zyft"}</div>
            <div className="sidebar__tagline">The Voice of Gifting</div>
          </div>
        </div>

        <nav className="sidebar__nav">
          <NavLink
            to="/dashboard"
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <DashboardIcon className="nav-icon" />
            <span>Dashboard</span>
          </NavLink>

          {user?.role === "company_admin" && (
            <>
              <div className="nav-sectionLabel">Wishes</div>

              <NavLink
                to="/employees"
                className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
              >
                <UsersIcon className="nav-icon" />
                <span>Employees</span>
              </NavLink>

              <NavLink
                to="/select-festival"
                className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
              >
                <SparklesIcon className="nav-icon" />
                <span>AI Wishes</span>
              </NavLink>
            </>
          )}
          <NavLink
            to="/gifting"
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <SparklesIcon className="nav-icon" />
            <span>AI Gifting</span>
          </NavLink>

          <NavLink
            to="/calendar"
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <CalendarIcon className="nav-icon" />
            <span>Calendar</span>
          </NavLink>

          <NavLink
            to="/wishes-badges"
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <SparklesIcon className="nav-icon" />
            <span>Wishes & Badges</span>
          </NavLink>

          <NavLink
            to="/transcript-ingests"
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <CalendarIcon className="nav-icon" />
            <span>Transcript ingests</span>
          </NavLink>

          {user?.role !== "company_admin" && (
            <NavLink
              to="/memories"
              className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
            >
              <FolderIcon className="nav-icon" />
              <span>Memories</span>
            </NavLink>
          )}

          {user?.role === "company_admin" && (
            <>
              <div className="nav-sectionLabel">Admin</div>

              <NavLink
                to="/admin/people"
                className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
              >
                <UsersIcon className="nav-icon" />
                <span>People</span>
              </NavLink>

              <NavLink
                to="/admin/branding"
                className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
              >
                <PaletteIcon className="nav-icon" />
                <span>Branding</span>
              </NavLink>

              <NavLink
                to="/admin/memories"
                className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
              >
                <FolderIcon className="nav-icon" />
                <span>Employee Moments</span>
              </NavLink>

              <NavLink
                to="/admin/org-units"
                className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
              >
                <UsersIcon className="nav-icon" />
                <span>B360U Mapping</span>
              </NavLink>
            </>
          )}
        </nav>

        <div className="sidebar__footer">
          <div className="sidebar__notifRow">
            <NotificationBell />
          </div>
          <div className="sidebar__user">
            <div className="sidebar__userName">{user?.email || "Signed in"}</div>
            <div className="sidebar__userMeta">{user?.role || "user"}</div>
          </div>

          <div className="sidebar__actions">
            <button
              className="btn btn--ghost"
              onClick={() => setDarkMode(!darkMode)}
              title={darkMode ? "Switch to light mode" : "Switch to dark mode"}
              type="button"
            >
              {darkMode ? <SunIcon className="icon" /> : <MoonIcon className="icon" />}
              <span>{darkMode ? "Light" : "Dark"}</span>
            </button>

            <button className="btn btn--secondary" onClick={handleLogout} type="button">
              Logout
            </button>
          </div>
        </div>
      </aside>

      {/* Main */}
      <main className={`app-main ${isAIGiftingPage ? "app-main--ai-gifting" : ""}`}>{children}</main>
      <ZyftPandaChatbot />
    </div>
  );
};

export default Layout;
